/**
 * Module dependencies.
 */

import React from 'react';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  children?: React.ReactNode;
};

/**
 * Export `Text` component.
 */

export function Text({ children, className }: Props): JSX.Element {
  return <span className={cn('text-foreground', className)}>{children}</span>;
}
